import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getClassNameFactory } from "@dcl/ui";

var Logo = /*#__PURE__*/function (_React$Component) {
  _inherits(Logo, _React$Component);

  var _super = _createSuper(Logo);

  function Logo() {
    var _this;

    _classCallCheck(this, Logo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getLogoDescendantName", function () {
      return _this.props.isPrideMonth ? "logoInnerPrideMonth" : "logoInner";
    });

    return _this;
  }

  _createClass(Logo, [{
    key: "render",
    value: function render() {
      var getClassName = getClassNameFactory("SiteHeader");
      var _this$props = this.props,
          logoHref = _this$props.logoHref,
          logoText = _this$props.logoText;
      return /*#__PURE__*/React.createElement("a", {
        "data-is-pride-logo-enabled": this.props.isPrideMonth,
        className: getClassName({
          descendantName: "logo"
        }),
        href: logoHref
      }, /*#__PURE__*/React.createElement("div", {
        id: "logo",
        className: getClassName({
          descendantName: this.getLogoDescendantName()
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "logoInnerLabel",
          utilities: "hiddenVisually"
        })
      }, logoText)));
    }
  }]);

  return Logo;
}(React.Component);

export default Logo;